import React, { useState } from "react";
import { verifyEmail } from  "./authService";
import Swal from "sweetalert2";
const VerifyEmail: React.FC<{
  mobile: string;
  maskedEmail: string;
  onSuccess: () => void;
}> = ({ mobile, maskedEmail, onSuccess }) => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");

  const handleVerify = async () => {
    try {
      await verifyEmail(mobile, email);
      onSuccess();
      Swal.fire({
                  title: "Success",
                  text: "An email sent to registered eMail ID, please login to change the Password",
                  icon: "success",
                  confirmButtonText: "OK",
                }).then(async (result) => {
                  
                });

    } catch (err: any) {
      setError(err.response?.data || "Email verification failed");
    }
  };

  return (
    <div>

      <div className="modal-content">
      <div className="modal-header border-bottom-0 row">
       <button type="button" className="btn-close"  data-bs-dismiss="modal" aria-label="Close"></button>
       <h5 className="cme-header">Verify Email</h5></div>
       <div className="modal-body pb-5">    
          <p><label>Registered Email: <strong>{maskedEmail}</strong> </label></p>
      

      <input
        type="email"
        placeholder="Enter full email address"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />

      <button onClick={handleVerify} data-bs-dismiss="modal">Verify & Send Link</button>

      {error && <p style={{ color: "red" }}>{error}</p>}
    </div>
    </div>
    </div>
    

  );
};

export default VerifyEmail;
